export enum QuotesRFQApi {
  ExportPDF = '/quote/:quoteId/rfq-export-pdf',
  PreviewPDF = '/quote/:quoteId/rfq-export-preview',
  Get = '/quote/:quoteId',
  UpdateProfilePhoto = '/quote/:quoteId/uploadProfileImage',
  UpdatePreviewInfo = '/quote/:quoteId/previewInfo',
  Update = '/quote/:quoteId/edit-quote',
  UpdateItem = '/quote/:quoteId/item',
  Configurations = '/quote/configuration',
  Create = '/quote/create',
  GetStatuses = '/quote/statuses',
  UpdateQuoteStatus = '/quote/:quoteId/status',
  RenewQuotes = '/quote/:quoteId/renew',
  DeleteQuote = '/quote/:quoteId',
  Summary = '/quote/summary-stats'
}

export enum QuotesV2Api {
  Configuration = '/v2/quote/configuration',
  Statuses = '/v2/quote/statuses',
  UpdateStatus = '/v2/quote/:quoteId/status',
  Get = '/v2/quote/:quoteId',
  Delete = '/v2/quote/:quoteId',
  Renew = '/v2/quote/:quoteId/renew',
  Create = '/v2/quote/create',
  ItemsMetadata = '/v2/quote/:quoteId/items/metadata',
  Items = '/v2/quote/:quoteId/items',
  AddProducts = '/v2/quote/:quoteId/items/products',
  AddFreehand = '/v2/quote/:quoteId/items/freehand',
  // DEV-819 — staged image upload for SPO (freehand) items: multipart field
  // `image`, answers { imageId, path, size }. Nothing is attached to an item
  // here — the returned ids are sent on freehand create/update, which is what
  // lets the modal show per-file progress and reorder before the item exists.
  UploadItemImage = '/v2/quote/:quoteId/items/images',
  // DEV-819 — `:itemId` must be a FREEHAND row (top-level SPO or SPO sub-item).
  UpdateFreehand = '/v2/quote/:quoteId/items/:itemId/freehand',
  UpdateItemPricing = '/v2/quote/:quoteId/items/:itemId/pricing',
  UpdateItemQuantity = '/v2/quote/:quoteId/items/:itemId/quantity',
  UpdateItemNote = '/v2/quote/:quoteId/items/:itemId/note',
  UpdateItemLabels = '/v2/quote/:quoteId/items/:itemId/labels',
  RefreshItemPrice = '/v2/quote/:quoteId/items/:itemId/refresh-price',
  AddSubitem = '/v2/quote/:quoteId/items/:itemId/subitems',
  // DEV-637 — `:itemId` must be a SUB-ITEM row whose parent is a product row.
  MakePrimary = '/v2/quote/:quoteId/items/:itemId/make-primary',
  // DEV-637 — `:itemId` is the PRODUCT LINE being replaced; the body's
  // `productId` must be one of that line's own `alternates`.
  ReplaceWithAlternate = '/v2/quote/:quoteId/items/:itemId/replace-with-alternate',
  UpdateSubitem = '/v2/quote/:quoteId/items/:itemId/subitems/:subId',
  DeleteSubitem = '/v2/quote/:quoteId/items/:itemId/subitems/:subId',
  CreateSection = '/v2/quote/:quoteId/sections',
  UpdateSection = '/v2/quote/:quoteId/sections/:sectionId',
  DeleteSection = '/v2/quote/:quoteId/sections/:sectionId',
  MoveItems = '/v2/quote/:quoteId/items/move',
  DeleteItem = '/v2/quote/:quoteId/items/:itemId',
  GetQuotes = '/v2/quote/search',
  GetSharedQuotes = '/v2/quote/search/shared',
  SummaryStats = '/v2/quote/summary-stats',
  SharedSummaryStats = '/v2/quote/summary-stats/shared',
  PreviewPDF = '/v2/quote/:quoteId/rfq-export-preview',
  ExportPDF = '/v2/quote/:quoteId/rfq-export-pdf',
  ExportCSV = '/v2/quote/:quoteId/export-csv',
  ExportExcel = '/v2/quote/:quoteId/export-excel',
  RefreshAllPrices = '/v2/quote/:quoteId/items/refresh-all-prices',
  UpdatePreviewInfo = '/v2/quote/:quoteId/previewInfo',
  UploadProfileImage = '/v2/quote/:quoteId/uploadProfileImage',
  Share = '/v2/quote/:quoteId/share',
  Shares = '/v2/quote/:quoteId/shares',
  RevokeShare = '/v2/quote/:quoteId/shares/:shareId/revoke',
  UnrevokeShare = '/v2/quote/:quoteId/shares/:shareId/unrevoke',
  AppendShareEmails = '/v2/quote-shares/:shareId/emails',
  ShowShareInSearch = '/v2/quote-shares/:shareId/show-in-search',
  QuoteShares = '/v2/quote-shares',
  QuoteShareDetail = '/v2/quote-shares/:shareId',
  InternalShare = '/v2/quote/:quoteId/internal-share',
  InternalShareUser = '/v2/quote/:quoteId/internal-share/:userId'
}
